import Welcome from "../Welcome";
import Products from "../Products";
import Hero from "../Hero";
import Loader from "../Loader/Loader";
const HomePage = ({products,addToCart,removeFromCart,cart,favourite,addToFavourite,removeFromFavourite, loading, gadgetType, onChangeSelect }) =>{
    
    return(
        <>
        {loading && <Loader/>}
        <Hero/>
        <Welcome/>
        <Products 
        products={products}
        addToCart={addToCart} 
        removeFromCart={removeFromCart} 
        cart ={cart} 
        favourite={favourite}
        addToFavourite = {addToFavourite}
        removeFromFavourite = {removeFromFavourite}
        gadgetType={gadgetType}
        onChangeSelect={onChangeSelect}
        />
        
        </>
    )
}

export default HomePage;